const NoPage = () => {
    return <h1>404 Found</h1>;
}

export default NoPage;